import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { NEARBY_ARENAS, NEXT_GAME, NearbyArena, SPORTS } from 'modules/jogador/player-home/content';
import { lowestCourtPrice, useArenaProfile } from 'shared/contexts/ArenaProfileContext';
import { fetchPlayerHome } from 'modules/jogador/player-home/playerHomeService';

export function usePlayerHome() {
  const [sport, setSport] = useState<string>(SPORTS[0]);

  const { data, isLoading, error } = useAsyncData(
    () => fetchPlayerHome(sport),
    { nextGame: NEXT_GAME, nearbyArenas: NEARBY_ARENAS },
    [sport]
  );

  // A arena cadastrada na demonstração aparece no topo da lista do jogador.
  const { profile, isCustom } = useArenaProfile();
  const ownArena: NearbyArena | null = isCustom
    ? {
        id: 'demo-own-arena',
        name: profile.arenaName,
        distanceKm: 0.8,
        courts: profile.courts.length,
        surface: profile.unitName,
        rating: 0,
        priceFrom: lowestCourtPrice(profile),
        isNew: true,
      }
    : null;
  const nearbyArenas = ownArena ? [ownArena, ...data.nearbyArenas] : data.nearbyArenas;

  return { sport, setSport, sports: SPORTS, ...data, nearbyArenas, isLoading, error };
}
